import Image from "next/legacy/image"
import { renderTime } from "utils/time"
import Link from "next/link"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
// import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import { getAccessToken } from "lib/Cookies"
import { Modal } from "components/ui"

export default function Component(props) {
  let display_type = true
  const router = useRouter()
  const { togleModalLogin, signKey, userInfo } = useStore()
  const { status, id, type, is_protected, is_url_external, url_external } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // togleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    togleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current) {
      if (is_url_external && url_external) {
        window.open(url_external, "_blank")
      } else router.push(`/video?id=${id}&type=${type}`)
    }
  }, [signKey, userInfo])

  useEffect(() => {
    if (window.innerWidth < 1080) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  if (status !== "live") {
    return <div>{!isMobile ? <CardLiveHorizontal {...props} /> : <CardLiveVertical {...props} />}</div>
  } else {
    return (
      <>
        <Link
          target={is_url_external && url_external ? "_blank" : ""}
          href={is_url_external ? url_external : `/video?id=${id}&type=${type}`}
        >
          <div onClick={onClick} role="button" tabIndex="0" onKeyPress={() => {}}>
            {!isMobile ? <CardLiveHorizontal {...props} /> : <CardLiveVertical {...props} />}
          </div>
        </Link>
        <Modal
          isOpen={isModal}
          onCancel={() => {
            setIsModal(false)
          }}
          showIcon={false}
        >
          <div className="p-6 text-center bg-dark-700 max-w-md">
            <div className="text-dark-100 font-semibold mb-6 text-2xl">Thông báo</div>
            <div>
              <div className="mb-2 text-base">Bạn cần đăng nhập để sử dụng tính năng này</div>
              <hr className="mt-6" style={{ borderTop: "solid 0.5px", opacity: "0.3" }} />
              <div className="mt-2">
                <button className="p-2 mr-8" onClick={onClose}>
                  Hủy
                </button>
                <button className="p-2 " onClick={onNext}>
                  <span className="text-primary-500 font-bold">Đăng nhập</span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

function CardLiveHorizontal({ attribute, status, location, start_time, league_name }) {
  const setModalLive = useStore().setModalLive
  const { away_logo, away_name, away_score, home_logo, home_name, home_score } = attribute || {}

  function nextPath() {
    if (status !== "live") {
      setModalLive({
        show: true,
        isVod: false,
        info: {
          home_name,
          away_name,
          start_time
        }
      })
    }
  }
  return (
    <div onClick={nextPath} role="button" tabIndex="0" onKeyPress={() => {}}>
      <div className="bg-dark bg-opacity-50 border-dark-900 border rounded-2xl text-dark-500 relative ">
        <div className="mb-4 my-2 text-sm line-clamp-1 text-center h-5 px-14 overflow-y-hidden lg:block hidden">
          {league_name}
        </div>
        <div className="grid grid-cols-2 gap-4 relative">
          <div className="text-center col-span-1">
            <Image src={home_logo} width={48} height={48} alt={home_name} />
          </div>
          <div className="text-center absolute left-1/2 top-0 transform  -translate-x-1/2">
            <div className="text-dark-100 font-semibold text-2xl">
              {status === "live" ? (
                <>
                  {home_score} - {away_score}
                </>
              ) : (
                <>-</>
              )}
              {/* {home_score} - {away_score} */}
            </div>
          </div>
          <div className="text-center col-span-1">
            <Image src={away_logo} width={48} height={48} alt={away_name} />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 text-dark-100 text-sm font-semibold mb-4 px-2">
          <div className="col-span-1 text-center line-clamp-1">{home_name}</div>
          <div className="col-span-1 text-center line-clamp-1">{away_name}</div>
        </div>
        <div className="lg:flex justify-between text-xs border-dark-900 border-t px-4 py-2">
          <div className="line-clamp-1">{location}</div>
          <div className="">{renderTime(start_time)}</div>
        </div>
        {status === "live" && (
          <div className="absolute top-2 left-2 bg-dark-50 rounded-xl flex items-center px-1">
            <div className=" rounded-full h-2 w-2 bg-red-500 mr-1"></div>
            <div className="text-dark-800 mr-1 flex items-center" style={{ fontSize: 10 }}>
              LIVE
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
function CardLiveVertical({ attribute, status, location, start_time, league_name }) {
  const setModalLive = useStore().setModalLive
  const { away_logo, away_name, away_score, home_logo, home_name, home_score } = attribute

  function nextPath() {
    if (status !== "live") {
      setModalLive({
        show: true,
        isVod: false,
        info: {
          home_name,
          away_name,
          start_time
        }
      })
    }
  }

  return (
    <div onClick={nextPath} role="button" tabIndex="0" onKeyPress={() => {}}>
      <div className="bg-dark bg-opacity-50 border-dark-900 border rounded-2xl text-dark-500 relative p-1">
        <div className="mb-2 my-2 text-sm line-clamp-1 text-center h-5 px-14 overflow-y-hidden"></div>
        <div className="grid grid-cols-2 gap-4 relative mb-2 px-3">
          <div className="text-center col-span-1">
            <Image src={home_logo} width={40} height={40} alt={home_name} />
          </div>
          <div className="text-center col-span-1">
            <Image src={away_logo} width={40} height={40} alt={away_name} />
          </div>
        </div>
        <div className="text-dark-100 font-semibold mb-4 text-xs px-2 space-y-1 ">
          <div className="flex justify-between mb-1">
            <div className="line-clamp-1 w-[90px]">{home_name}</div>
            <div>{status === "live" ? home_score : "-"}</div>
          </div>
          <div className="flex justify-between">
            <div className="line-clamp-1 w-[90px]">{away_name}</div>
            <div>{status === "live" ? away_score : "-"}</div>
          </div>
        </div>
        <div className="lg:flex justify-between text-xs border-dark-900 border-t px-4 py-2">
          {/* <div className="line-clamp-1">{location}</div> */}
          <div className="">{renderTime(start_time)}</div>
        </div>
        {status === "live" && (
          <div className="absolute top-3 left-3 bg-dark-50 rounded-xl flex items-center px-1">
            <div className=" rounded-full h-2 w-2 bg-red-500 mr-1"></div>
            <div className="text-dark-800 mr-1 flex items-center" style={{ fontSize: 10 }}>
              LIVE
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
